import { Vue, Component } from 'nuxt-property-decorator';

import { transformIntoMoney } from '~/components/utils/core/number';
import { PRIZE } from '~/constants/referral';

@Component({
  name: 'ReferralPrizeMixin',
})
export default class ReferralPrizeMixin extends Vue {
  get moneyPrize(): string {
    const DEFAULT_KEY = 'United States of America';
    const userCountry = (this.$auth.user.city?.countryName ?? DEFAULT_KEY) as keyof typeof PRIZE;

    return transformIntoMoney(PRIZE[userCountry] ?? PRIZE[DEFAULT_KEY]);
  }
}
